import { observer } from 'mobx-react';

function ChatLoadingDots() {
  return (
    <div className="flex space-x-1 px-4 py-6">
      <span className="w-2 h-2 bg-gray-500 rounded-full animate-elevateDot !bg-[gray] animation-delay-0"></span>
      <span className="w-2 h-2 bg-gray-500 rounded-full animate-elevateDot !bg-[gray] animation-delay-2"></span>
      <span className="w-2 h-2 bg-gray-500 rounded-full animate-elevateDot !bg-[gray] animation-delay-4"></span>
    </div>
  );
}

export default observer(ChatLoadingDots);
